import React from "react";
import { Link } from "react-router-dom";

export default function DesktopPrimaryNav({
  desktopTabs,
  isDesktopTabActive,
  desktopSearchOpen,
  openDesktopSearch,
  desktopSearchInputRef,
  handleDesktopSearchSubmit,
  desktopSearchCategory,
  setDesktopSearchCategory,
  desktopSearchQuery,
  setDesktopSearchQuery,
  setDesktopSearchOpen,
  SearchIcon,
  CloseIcon,
}) {
  return (
    <div className="mt-2 flex items-center justify-between gap-3">
      <nav className="flex items-center gap-1 flex-wrap" aria-label="Primary desktop navigation">
        {desktopTabs.map((item) => {
          const active = isDesktopTabActive(item.to);
          return (
            <Link
              key={item.id}
              to={item.to}
              className={`px-3 py-1.5 text-sm font-medium transition flex items-center rounded-lg ${
                active
                  ? "text-green-950 bg-emerald-100/80 shadow-sm"
                  : "text-emerald-50 hover:text-white hover:bg-emerald-200/30"
              }`}
            >
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="hidden md:flex items-center justify-end min-w-[320px]">
        {!desktopSearchOpen ? (
          <button
            onClick={openDesktopSearch}
            className="h-9 w-9 rounded-xl border border-emerald-300/60 bg-green-950/45 text-emerald-50 hover:bg-green-900/70 hover:border-emerald-200 transition flex items-center justify-center"
            aria-label="Open search"
          >
            <SearchIcon size={16} />
          </button>
        ) : (
          <form
            onSubmit={handleDesktopSearchSubmit}
            className="w-full max-w-[520px] h-9 rounded-xl border border-emerald-200/55 bg-white/15 backdrop-blur-sm flex items-center overflow-hidden"
          >
            <select
              value={desktopSearchCategory}
              onChange={(event) => setDesktopSearchCategory(event.target.value)}
              className="h-full px-3 text-sm font-medium bg-emerald-100/90 text-green-950 border-r border-emerald-200/70 focus:outline-none"
              aria-label="Search catalogue"
            >
              <option value="all">Catalogue</option>
              <option value="farm">Farm</option>
              <option value="farmpulse">FarmPulse</option>
              <option value="farmmark">FarmMark</option>
              <option value="northstar">NorthStar</option>
              <option value="platform">Our Platform</option>
            </select>
            <div className="flex items-center gap-2 px-3 flex-1">
              <SearchIcon size={15} className="text-emerald-100" />
              <input
                ref={desktopSearchInputRef}
                type="text"
                value={desktopSearchQuery}
                onChange={(event) => setDesktopSearchQuery(event.target.value)}
                className="w-full bg-transparent text-sm text-white placeholder:text-emerald-100/80 focus:outline-none"
                placeholder="Search for items"
                aria-label="Search for items"
              />
            </div>
            <button
              type="button"
              onClick={() => {
                setDesktopSearchOpen(false);
                setDesktopSearchQuery("");
              }}
              className="h-full px-2 text-emerald-100 hover:text-white"
              aria-label="Close search"
            >
              <CloseIcon size={15} />
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
